/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_Cancel_BackInputs */

const en_settings_billing_cancel_back = /** @type {(inputs: Settings_Billing_Cancel_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep subscription`)
};

const zh_settings_billing_cancel_back = /** @type {(inputs: Settings_Billing_Cancel_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保留订阅`)
};

/**
* | output |
* | --- |
* | "Keep subscription" |
*
* @param {Settings_Billing_Cancel_BackInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_billing_cancel_back = /** @type {((inputs?: Settings_Billing_Cancel_BackInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_Cancel_BackInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_billing_cancel_back(inputs)
	return zh_settings_billing_cancel_back(inputs)
});
export { settings_billing_cancel_back as "settings.billing.cancel_back" }